import React from 'react';
import css from './ProfilePage.module.css';
import { FormattedMessage } from 'react-intl';
import Icons from '../../components/Icons/Icons';
import { H4 } from '../../components';
import { getLabelFromKey, isArrayLength } from '../../util/genericHelpers';
import { constructionStageOptions, energySolutionsOptions } from '../../util/general';

const renderArraySection = (headingId, keys, options) => {
  if (!isArrayLength(keys)) return null;

  return (
    <>
      <H4 as="h4">
        <FormattedMessage id={headingId} />
      </H4>
      <div className={css.serviceList}>
        {keys.map((key, index) => (
          <div key={index} className={css.service}>
            <Icons name="check" /> {getLabelFromKey(key, options)}
          </div>
        ))}
      </div>
    </>
  );
};

const HouseQueriesSection = ({ publicData = {} }) => {
  const { constructionStageOptions: constructionStages, energySolutions } = publicData;
  return (
    <div className={css.infoBlock}>
      <h2>
        <FormattedMessage id="ProfilePage.houseQueries" />
      </h2>

      {renderArraySection(
        'ProfilePage.constructionStage.heading',
        constructionStages,
        constructionStageOptions
      )}

      {renderArraySection(
        'ProfilePage.energySolutions.heading',
        energySolutions,
        energySolutionsOptions
      )}
    </div>
  );
};

export default HouseQueriesSection;
